export default defineNuxtPlugin({
	name: "error-handler",
	order: -1,
	setup: (nuxtApp) => {
		nuxtApp.hook("vue:error", (error) => {
			console.error("[Nuxt vue:error]:", error);
		});
	},
});
